import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate() {

    if (!this.authService.isLoggedIn() || this.authService.isTokenExpired()) {
      this.router.navigate(['/auth/login']);
      return false; 
    } else {
      return true;
    }
  }

}